exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "od-buyer-faqs .faq-container{margin-bottom:3em}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/less-loader/lib/loader.js!./javascripts/market/components/od-buyer-faqs.less
 ** module id = 3450
 ** module chunks = 3
 **/